import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import '../clients/ClientManage.scss';
import { getAllClients, createNewClientService, deleteClientService, editClientService } from '../../../services/clientService';
import ModalClient from './ModalClient';
import ModalEditClient from './ModalEditClient';
import { emitter } from '../../../utils/emitter' // ham tao su kien
class ClientManage extends Component {

    constructor(props) { // Ham khoi tao
        super(props);
        this.state = {
            arrClients: [],
            isOpenModal: false,
            isOpenModalEditClient: false,
            ClientEdit: [],
        }
    }

    async componentDidMount() {  // set bien, goi api
        await this.getAllClientFromReact()

    }
    getAllClientFromReact = async () => {
        let response = await getAllClients("All");
        if (response && response.errCode == 0) {
            this.setState({
                arrClients: response.Clients
            })
            console.log(this.state.arrClients);
        }
    }
    createNewClient = async (data) => {

        try {
            let response = await createNewClientService(data);
            if (response && response.errCode !== 0) {
                await this.getAllClientFromReact()
                this.setState({
                    isOpenModal: false,
                })
                emitter.emit('EVENT_CLEAR_MODAL_DATA', { "id": "your id" });

            } else {
                console.log("Client didn't create");
            }

        } catch (error) {

        }
    }
    editClient = async (data) => {
        try {
            let response = await editClientService(data);
            if (response && response.errCode !== 0) {
                await this.getAllClientFromReact()
                this.setState({
                    isOpenModalEditClient: false,
                })
                // emitter.emit('EVENT_CLEAR_MODAL_DATA', { "id": "your id" });
                console.log('trang thai tra ve ham edit: ', response)
            } else {
                console.log("Client didn't create");
            }

        } catch (error) {

        }
    }
    handleAddNewClient = () => {
        this.setState({
            isOpenModal: true
        })
        // alert("from handleAddNewClient");
    }
    handleDeleteClient = async (data) => {

        let response = await deleteClientService(data);
        if (response && response.errCode !== 0) {
            await this.getAllClientFromReact()
            this.setState({
                isOpenModal: false,
            })

        } else {
            console.log("Client didn't create");
        }

    }
    handleEditClient = async (data) => {

        this.setState({
            isOpenModalEditClient: true,
            ClientEdit: data
        })
    }
    toogleClientModal = () => {
        this.setState({
            isOpenModal: !this.state.isOpenModal
        })
    }
    toogleClientEditModal = () => {
        this.setState({
            isOpenModalEditClient: !this.state.isOpenModalEditClient
        })
    }
    render() {
        console.log('check render : ', this.state.isOpenModal);
        let arrClients = this.state.arrClients;
        // console.log('check render : ', arrClients);
        // props - properties, nested, lay data tu Thang cha chuyen cho thang con, thang cha lay du lieu goc tu API
        return (
            <div className="Clients-container">
                <ModalClient
                    isOpen={this.state.isOpenModal}
                    tooglefromParent={this.toogleClientModal}
                    createNewClient={this.createNewClient}
                />
                {this.state.isOpenModalEditClient &&
                    <ModalEditClient
                        isOpen={this.state.isOpenModalEditClient}
                        tooglefromParent={this.toogleClientEditModal}
                        currentClient={this.state.ClientEdit}
                        editCurrentClient={this.editClient}
                    // createNewClient={this.createNewClient}
                    />
                }

                <div className='title text-center'> Manage Client by Admin</div>
                <div className="mx-1">
                    <button class="btn btn-primary px-3"
                        onClick={() => this.handleAddNewClient()}
                    ><i class="fas fa-plus"></i>Add new staff</button>

                </div>
                <div className='Client-table mt-3 mx-1'>
                    <table id="customers">
                        <tr>
                            <th>email</th>
                            <th>Name</th>
                            <th>Address</th>
                            <th>Actions</th>
                        </tr>

                        {/* su dung vong lap MAP function javascript */}
                        {arrClients && arrClients.map((item, index) => {
                            // console.log('check map', item, index);
                            return (
                                <tr>

                                    <td>{item.email}</td>
                                    <td>{item.fullname}</td>
                                    <td>{item.address}</td>
                                    <td>
                                        <button className='btn-edit'
                                            onClick={() => this.handleEditClient(item)}
                                        ><i class="fas fa-pencil-alt"></i></button>
                                        <button className='btn-delete'
                                            onClick={() => this.handleDeleteClient(item)}
                                        > <i className="fas fa-trash-alt"></i></button>

                                    </td>
                                </tr>

                            )
                        })
                        }



                    </table>
                </div>
            </div >
        );
    }

}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientManage);
